import api from '../../../api'
import { browserHistory } from 'react-router'
import createStore from '../../../store/createStore'

export const MAIN = 'MAIN'
export const DOCTOR_INFO = 'DOCTOR_INFO'
export const LOADING_CHANGE = 'LOADING_CHANGE'
export const SNACK = 'SNACK'
export const GET_SETTINGS_APP = 'GET_SETTINGS_APP'

export function userInfo () {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      if (localStorage && typeof localStorage.doctor !== 'undefined') {
        setTimeout(function () {
          dispatch({
            type: DOCTOR_INFO,
            payload: { doctor: JSON.parse(localStorage.doctor) }
          })
          resolve()
        }, 300)
      }
    })
  }
}

export const getValidPoints = () => {
  return createStore.getState().main.appsettings.validPoints
}

export const settingsAPP_NOADMIN = () => {
  return new Promise((resolve, reject) => {
    api.get('/settings/app')
    .then(appSettings => {
      createStore.dispatch(
        {
          type: GET_SETTINGS_APP,
          payload: appSettings
        }
      );
      resolve();
    }, err => {
      reject(err);
    });
  });
}

export function changeLoading(boolean) {
	return(dispatch, getState) => {
		return new Promise((resolve, reject) => {
			dispatch({
				type: LOADING_CHANGE,
				payload: boolean
			})
			resolve();
		});
	}
}

export function snackAction(snack) {
	return(dispatch, getState) => {
		return new Promise((resolve, reject) => {
			dispatch({
				type: LOADING_CHANGE,
				payload: { snackBar: snack }
			})
			resolve();
		});
	}
}
export function logout () {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
    	localStorage.clear()
      browserHistory.push('/login')
      dispatch({
        type: 'STATE_RESET'
      })
      resolve()
    })
  }
}

const ACTION_HANDLERS = {
  [DOCTOR_INFO]: (state, action) => Object.assign({}, state, action.payload),
  [SNACK]: (state, action) => Object.assign({}, state, action.payload),
  [GET_SETTINGS_APP]: (state, action) => Object.assign({}, state, {
    appsettings: {
      ...state.appSettings,
      validPoints: action.payload.settings.validPoints
    }
  }),
  [LOADING_CHANGE]: (state, action) => {
    if (action.payload) {
      return Object.assign({}, state, {
        loading: state.loading + 1
      })
    }
    return Object.assign({}, state, {
      loading: state.loading - 1
    })
  }
}

const initialState = {
  loading: 0,
  appsettings: {
    validPoints: null
  }
}
export default function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Main/modules/main.js